import React from 'react';
import { Panel } from 'react-bootstrap';
import moment from 'moment';

import { fetchApi } from '../../Network/NetworkService';
import { notif } from '../Ui/Notification';
import isoDate from '../../Services/toIsoDate.js';

import IconTooltip from '../Ui/IconTooltip';
import DateRangePicker from '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.js';

export default class RecurrenceList extends React.Component {
    constructor() {
        super();

        this.state = {
            users: [],
            loading: false,
            countUsers: 0,
            dateRange: [moment().subtract({ month: 1 }).toDate(), moment().toDate()]
        };
    }

    getUsers() {
        this.setState({ loading: true });
   
        fetchApi(`/requests/analytics/recurrenceList?start=${isoDate(this.state.dateRange[0], 0, 0)}&end=${isoDate(this.state.dateRange[1], 23, 59, 59)}`)
            .then((res) => {
                this.setState({ users: res.data, loading: false, countUsers: res.countUsers })
            })
            .catch((err) =>
                notif.addNotification(
                    'Erreur',
                    'Erreur de recuperation des donnees Utilisateur: ' + err,
                    'warning'
                )
            );
    }

    componentDidMount() {
        this.getUsers();
    }


    render() {
        if (this.state.loading) {
            return <div>Récupération des données en cours...</div>;
        }
        const page = this.state.page;

        return (
            <div className="pT-25">

                <Panel>
                    <Panel.Heading>
                        <h6>Utilisateurs</h6>
                    </Panel.Heading>
                    <Panel.Body>
                        <div>
                            <div style={{ padding: '20px 0'}}>
                                <DateRangePicker clearIcon={null} onChange={value => this.setState({ dateRange: value })} value={this.state.dateRange} maxDate={new Date()}/>
                            </div>
                            <div style={{ display: 'flex', gap: 15, marginTop: 10 }}>

                                <p>
                                Liste des recurrences : {this.state.countUsers}
                                </p>

                            </div>
                        </div>
                        <div className="mT-40" />
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th style={{ width: 300 }}>
                                            Nom et prenom                      
                                        </th>
                                        <th style={{ width: 300 }}>
                                            Email                       
                                        </th>
                                        <th style={{ width: 150 }}>Nombre de tlc</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.users.map((d, idx) => (
                                        <tr key={d._id}>
                                            <td>{idx + 1}</td>
                                            <td>{d.FName} {d.LName}</td>
                                            <td>
                                                {d.email}
                                            </td>
                                            <td>{d.request.length}</td>
                                            <td>
                                                {d.request.map((r, i) => (
                                                    <div style={{ padding: '20px 0', borderBottom: i + 1 < d.request.length ? '1px solid gray' : '' }} key={i}>
                                                        <p>{i + 1}{i + 1 === 1 ? 'er' : 'eme'} tlc: {r.type}, {moment(r.createdAt).format('DD/MM/YYYY HH:mm')}</p>
                                                    </div>
                                                ))}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Panel.Body>
                </Panel>
            </div>
        );
    }
}
